import authApi from 'api/authApi';
// import { removeAxiosApiKey } from 'api/axiosClient';
import AppResource from 'general/constants/AppResource';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import Utils from 'general/utils/Utils';

const UserHelper = {
  // Get display name
  getDisplayName: (user) => {
    let displayName = '';
    if (user) {
      return user.displayName ?? user.username;
    }
    return displayName;
  },

  // Get display name and phone
  getDisplayNameAndPhone: (user) => {
    let displayName = '';
    if (user) {
      displayName = user.fullname ?? user.username;

      if (user.phone) {
        displayName = displayName.concat(` - ${user.phone}`);
      }
    }
    return displayName;
  },

  // Check api key valid
  checkApiKeyValid: () => {
    // console.log(localStorage.getItem("saymee_admin_apiKey")); 
    return true;
    const apiKey = localStorage.getItem(PreferenceKeys.apiKey);

    if (apiKey) {
      return true;
    }

    return false;
  },

  checkAcountAndPassword: async (params) => {
    let auth;
    // console.log(params);
    if (params != null)
      auth = await authApi.signIn(params);
    else {
      const params = { username: localStorage.getItem(PreferenceKeys.savedLoginAccount), password: localStorage.getItem(PreferenceKeys.savedLoginPassword) };
      auth = await authApi.signIn(params);
    }

    // console.log(auth);

    switch (auth.status) {
      case 0:
        return false;
      case 1:
        if (params != null) {
          localStorage.setItem(PreferenceKeys.savedLoginAccount, params.username);
          localStorage.setItem(PreferenceKeys.savedLoginPassword, params.password);
        }
        return true;
      default:
        console.log('Error');
        return false;
    }
  },

  // Sign out
  signOut: () => {
    localStorage.removeItem(PreferenceKeys.apiKey);
    // removeAxiosApiKey();
  },

  getAccountAvatar: (account) => {
    const avatar = account?.avatar;
    if (avatar) {
      return Utils.getFullUrl(avatar);
    } else {
      return AppResource.icons.keens.avatarBoy;
    }
  },
};

export default UserHelper;
